
import React from 'react';
const CheckCircleBold = (props: React.SVGProps<SVGSVGElement>) =>
(

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_8005_36737)">
            <path d="M14.6693 7.38662V7.99995C14.6685 9.43757 14.2029 10.8364 13.3422 11.9878C12.4814 13.1393 11.2715 13.9816 9.89284 14.3892C8.51422 14.7968 7.04078 14.7479 5.69225 14.2497C4.34373 13.7515 3.19237 12.8307 2.40991 11.6247C1.62745 10.4186 1.2558 8.99199 1.35039 7.55749C1.44498 6.12299 2.00074 4.7575 2.93479 3.66467C3.86884 2.57183 5.13113 1.81021 6.5334 1.49338C7.93567 1.17656 9.40278 1.32151 10.7159 1.90662"
                stroke="currentColor"
                strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.6667 2.66663L8 9.33996L6 7.33996"
                stroke="currentColor"
                strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_8005_36737">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>


);


export default CheckCircleBold;




